// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

export const ImageSizeFragmentDoc = `
    fragment imageSize on ImageSize {
  url
  width
  sources {
    url
    mimeType
  }
}
    `;